export const navigationOptions = {
	read: 'Marcar como no leídas',
	unread: 'Marcar como leidas'
};
